import { useState } from 'react';

const useHoverCoordinates = () => {
    const [hoverCoords, setHoverCoords] = useState(null);

    const handleHover = (lat, lng) => {
        setHoverCoords([lat, lng]);
    };

    const handleHoverOut = () => {
        setHoverCoords(null);
    };

    return { hoverCoords, handleHover, handleHoverOut };
};

export default useHoverCoordinates;